<template>
  <div class="animated fadeIn">
    <b-modal
      title="ATTENZIONE"
      class="modal-success"
      v-model="okDel"
      @ok="okDel=false,elimina2()"
      ok-variant="success"
      :ok-only="false"
    >
    <template slot="modal-cancel">NO</template>
    <template slot="modal-ok">SI</template>
      Vuoi davvero eliminare questo messaggio ?
    </b-modal>
    <h1 v-if="messaggi.length==0">Non ci sono messaggi</h1>
    <div v-else>
      <h1>Messaggi</h1>
      <div>
        <button class="btn btn-info" :disabled="currmess==0" @click="currmess=0"><i class= "fa fa-fast-backward"></i></button>
        <button class="btn btn-info" :disabled="currmess==0" @click="currmess--"><i class= "fa fa-backward"></i></button>
        <button class="btn btn-info" :disabled="currmess==messaggi.length-1" @click="currmess++"><i class= "fa fa-forward"></i></button>
        <button class="btn btn-info" :disabled="currmess==messaggi.length-1"  @click="currmess=messaggi.length-1"><i class= "fa fa-fast-forward"></i></button>
      </div>
      <div v-html="messaggi[currmess].messaggio"></div>
      <div v-if="linkOK">
        <a :href="this.messaggi[this.currmess].link" target="_blank" @click="downloaded()">Vedi documento</a>
      </div>
      <br><br><br>
      <button class="btn btn-danger" @click="elimina" v-if="!enac"><i class= "fa fa-trash">Elimina</i></button>
    </div>
  </div>
</template>

<script>
import { API } from "@/api.js";

export default {
  name: "avvisi",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {
      okDel: false,
      messaggi: [],
      currmess: 0,
      check: false
    };
  },
  computed: {
    linkOK(){
      return this.messaggi.length && this.messaggi[this.currmess].link && this.messaggi[this.currmess].link.substring(0,4)=='http'
    },
    enac(){
      return window.ENAC
    }
  },
  updated(){
    if(this.messaggi.length) 
      this.seen()
  },
  beforeDestroy(){
    this.check = false
  },
  methods: {
    async verifica(){
      var url = new URL(window.location.href);
      let cid = this.getCorsID();
      if (cid) {
        let msgs = await API.sqlprep(this, "messaggi.get", [cid]);
        this.messaggi = msgs.data.dati
      }
      if(this.check)
        setTimeout(this.verifica, 1000*3600) // ogni ora
    },
    elimina(){
      this.okDel = true
    },
    elimina2(){
      API.sqlprep(this, "messaggi.got", [this.messaggi[this.currmess].id], {
        "@what": "eliminato"
      });
      this.messaggi.splice(this.currmess,1)
    },
    seen(){
      API.sqlprep(this, "messaggi.got", [this.messaggi[this.currmess].id], {
        "@what": "mostrato"
      });
    },
    downloaded(){
      API.sqlprep(this, "messaggi.got", [this.messaggi[this.currmess].id], {
        "@what": "letto"
      });
    },
  },
  mounted: async function() {
    this.check = true
    this.verifica()
  }
};
</script>

<style>
</style>
